(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function syncWoofVariant(section, updateUrl) {
    const select = section.querySelector('select[name="id"]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    const gallery = section.querySelector('.main-product__gallery');
    const media = [...gallery.children].find(item => item.dataset.mediaId === option.dataset.mediaId);
    if (media && gallery.firstElementChild !== media) {
      gallery.querySelector('.main-product__media--primary')?.classList.remove('main-product__media--primary');
      media.classList.add('main-product__media--primary');
      gallery.prepend(media);
      gallery.scrollTo({ left: 0, behavior: 'auto' });
    }
    const image = media?.querySelector('img');
    if (image) image.loading = 'eager';
    const price = section.querySelector('.main-product__price');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const submit = section.querySelector('.main-product__submit');
    if (submit) {
      submit.disabled = option.dataset.available !== 'true';
      submit.textContent = submit.disabled ? section.dataset.soldOutLabel : section.dataset.addLabel;
    }
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState(window.history.state, '', url);
    }
  }
  function initWoofProducts(scope) {
    const sections = [...scope.querySelectorAll('[data-woof-product]')];
    if (scope.matches?.('[data-woof-product]')) sections.unshift(scope);
    sections.forEach(section => {
      if (section.dataset.variantReady) return;
      section.dataset.variantReady = 'true';
      const select = section.querySelector('select[name="id"]');
      select?.addEventListener('change', () => syncWoofVariant(section, true));
      syncWoofVariant(section, false);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWoofProducts(document), { once: true });
  } else {
    initWoofProducts(document);
  }
  document.addEventListener('shopify:section:load', event => initWoofProducts(event.target));

  } catch(e) { console.error(e); }
})();
})();
